import(/* webpackMode: "eager", webpackExports: ["AdUnit"] */ "/vercel/path0/components/AdUnit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DynamicBackgroundEffects"] */ "/vercel/path0/components/DynamicBackgroundEffects.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/FortuneCookieInteractive.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
